import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TitleCard } from '@/core/components';

import { DoctoralCommittee } from '../../model/DoctoralCommitteeTypes';
import classes from './DoctoralCommitteeCard.module.css';

export interface DoctoralCommitteeCardProps {
  doctoralCommittee: DoctoralCommittee;
  to?: string;
  onClick?: () => void;
}

export function DoctoralCommitteeCard({ doctoralCommittee, to, onClick }: DoctoralCommitteeCardProps) {
  const { type, startYear, endYear, year, candidateName, doctoralSchoolName, coordinatorName } = doctoralCommittee;
  const { t } = useTranslation();

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="4px">
        <TitleCard
          title={candidateName}
          pre={
            <Group gap="3px">
              <Pill>{t(`doctoralCommittees.typeEnum.${type}`)}</Pill>
            </Group>
          }
        />
        <Group>
          <Text>{doctoralSchoolName}</Text>
        </Group>

        <Group>
          <Text>{coordinatorName}</Text>
        </Group>

        {type === 'GUIDANCE' ? (
          <Text
            c="dimmed"
            size="xs"
          >
            {startYear} - {endYear}
          </Text>
        ) : (
          <Text
            c="dimmed"
            size="xs"
          >
            {year}
          </Text>
        )}
      </Stack>
    </Paper>
  );
}
